// extracted by mini-css-extract-plugin
export default {"wrap":"ReferralView_wrap__8QMJD","tools":"ReferralView_tools__YbMuY","item":"ReferralView_item__vtIbZ","label":"ReferralView_label__4NaN-","value":"ReferralView_value__plKxJ"};